/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-12 17:35:34
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-13 17:07:23
 * @Content:
 */

import React, { FC, memo } from "react";
import { connect } from "react-redux";
import GamblingEndModal from "..";
import Modal from "../../../../components/Common/Modal/Modal";
import { activityInfoSelector } from "../../../../store/common/selector";
import "./index.less";

const PREFIX = "GamblingEndSuccessModal";

type IProps = {
  visible: boolean;
  onClose: () => void;
} & ReturnType<typeof mapStateToProps>;

const GamblingSuccessModal: FC<IProps> = memo(
  ({ visible, onClose, activityInfo }) => {
    return (
      <GamblingEndModal visible={visible} onClose={onClose} className={PREFIX}>
        <div>恭喜你！</div>
        <div>
          完成{activityInfo?.name || "挑战"}!
          奖金将在&nbsp;5&nbsp;个工作日内发放到你的钱包-红包中,敬请期待!
        </div>
      </GamblingEndModal>
    );
  }
);

const mapStateToProps = (state: any) => {
  return {
    activityInfo: activityInfoSelector(state),
  };
};

export default connect(mapStateToProps)(GamblingSuccessModal);
